<div class="space-y-4 list-container">
  <h1 class="text-2xl font-bold">Listagem de pedidos</h1>
  @if (error) {
    <app-alert [type]="'danger'">{{ error }}</app-alert>
  }
  <form (ngSubmit)="search()" autocomplete="on">
    <div class="flex gap-4 justify-between items-end border-none">
      <div class="flex gap-4">
        <div>
          <label class="block text-sm font-medium mb-1">Pedido</label>
          <input
            type="text"
            name="searchOrderId"
            autocomplete="on"
            [(ngModel)]="searchOrderId"
            (ngModelChange)="onOrderIdChange($event)"
            placeholder="Número do pedido (ex: 1604464154347-01)"
            class="control-height px-3 border rounded-md bg-white text-black dark:bg-neutral-900 dark:text-white w-[350px]"
          />
        </div>

        <div>
          <label class="block text-sm font-medium mb-1">CPF</label>
          <input
            type="text"
            inputmode="numeric"
            name="searchCpf"
            autocomplete="on"
            [(ngModel)]="searchCpf"
            placeholder="CPF (apenas números)"
            class="w-full control-height px-3 border rounded-md bg-white text-black dark:bg-neutral-900 dark:text-white"
            (ngModelChange)="onCpfChange($event)"
          />
        </div>

        <!-- <div>
          <label class="block text-sm font-medium mb-1">K do cliente</label>
          <input
            type="text"
            [(ngModel)]="searchClientK"
            placeholder="K do cliente (não implementado)"
            class="w-full control-height px-3 border rounded-md bg-white text-black dark:bg-neutral-900 dark:text-white"
            disabled
          />
        </div> -->
      </div>

      <div class="md:ml-2 flex gap-2">
        <app-button color="primary" type="submit">Buscar</app-button>
        <app-button color="primary" type="button" (buttonClick)="clear()">Limpar</app-button>
      </div>
    </div>
  </form>

  @if (loading) {
    <div class="my-4">
      <app-loading size="large" color="primary" />
    </div>
  }

  @if (!loading) {
    <div class="overflow-x-auto mt-2">
      <table class="table-auto w-full border-collapse border border-slate-400">
        <thead class="bg-neutral-100 dark:bg-neutral-700">
          <tr class="bg-neutral-100 dark:bg-neutral-700">
            <th class="border border-neutral-300 dark:border-neutral-600 p-2">ID do pedido</th>
            <th class="border border-neutral-300 dark:border-neutral-600 p-2">Data</th>
            <th class="border border-neutral-300 dark:border-neutral-600 p-2">Status</th>
            <th class="border border-neutral-300 dark:border-neutral-600 p-2"></th>
          </tr>
        </thead>



        <tbody>
          @for (o of data; track o.orderId; let even = $even) {
            <tr [ngClass]="even ? 'bg-neutral-50 dark:bg-neutral-800' : 'bg-white dark:bg-neutral-900'">
              <td class="border border-neutral-300 dark:border-neutral-600 p-2">
                <div class="font-medium">{{ o.orderId ?? '-' }}</div>
              </td>

              <td class="border border-neutral-300 dark:border-neutral-600 p-2">
                {{ asDateLabel(o.creationDate) }}
              </td>

              <td
                class="whitespace-pre-line border border-neutral-300 dark:border-neutral-600 p-2 p-3 text-m dark:border-neutral-700 dark:bg-neutral-900/50"
                [style.color]="o.details?.color ?? 'inherit'"
              >
                @if ($any(o).ganLoading) {
                  Carregando status do pedido
                } @else {
                {{ getDetailsLabel(o) }}

                @if (showGanExtra(o)) {
                  <ng-container>
                    &nbsp;|&nbsp;
                    @if (o.details?.gan?.tipoNf === 'MF') {
                      <ng-container>
                        MF gerada
                      </ng-container>
                    }

                    @if (o.details?.gan?.tipoNf === 'MF' && o.details?.gan?.inconPagto) {
                      <ng-container>
                        &nbsp;•&nbsp;
                      </ng-container>
                    }

                    @if (o.details?.gan?.inconPagto) {
                      <ng-container>
                        {{ o.details?.gan?.inconPagto }}
                      </ng-container>
                    }

                    @if (o.details?.status === 'payment-pending' && (o.details?.gan?.tipoNf === 'MF' || o.details?.gan?.inconPagto)) {
                      <ng-container>
                        &nbsp;•&nbsp;
                      </ng-container>
                    }

                    @if (o.details?.status === 'payment-pending') {
                      <ng-container>
                        Falta envio do billing
                      </ng-container>
                    }
                  </ng-container>
                }
                }
              </td>

              <td class="border border-neutral-300 dark:border-neutral-600 p-2">
                <div class="flex gap-1">
                  <app-button
                    color="primary"
                    size="small"
                    icon="eye"
                    (buttonClick)="openOrder(o.orderId)"
                  ></app-button>
                </div>
              </td>
            </tr>
          } @empty {
            <tr class="bg-neutral-50 dark:bg-neutral-800">
              <td colspan="6" class="p-3 text-sm text-center">Nenhum resultado.</td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    <app-pagination
      [paginationState]="paginationState"
      [onPaginationChange]="onPageChange"
    ></app-pagination>

    @if (notImplementedMessage) {
      <div class="mt-2">
        <app-alert [type]="'warning'">{{ notImplementedMessage }}</app-alert>
      </div>
    }
  }
</div>
